import React from 'react'

import {isEmpty} from 'es-toolkit/compat'

import './material-list-enumeration.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import Link from '../link'
import Tooltip from '../tooltip'
import TooltipHandler from '../tooltip-handler'

type Props = Overwrite<
  CommonProps<'ul'>,
  {
    children: string[]
    maxLength?: number
    moreLabel?: string
    showAll?: boolean
  }
>

const sliceList = (list: React.ReactNode[], maxLength: number) => {
  const truncatedList = list.slice(0, maxLength)
  const moreList = list.slice(maxLength)

  return [truncatedList, moreList] as const
}

const MaterialListEnumeration = ({
  className,
  children,
  maxLength = 5,
  showAll,
  moreLabel,
  ...props
}: Props) => {
  const [list, more] = sliceList(children, showAll ? children.length : maxLength)

  return (
    <ul {...props} className={cn('MaterialListEnumeration', {}, className)}>
      {list.map((child, index) => (
        <li key={index} className="MaterialListEnumeration__item">
          {child}
        </li>
      ))}
      {more.map((child, index) => (
        <li key={index} className="MaterialListEnumeration__item" hidden>
          {child}
        </li>
      ))}
      {!isEmpty(more) ? (
        <li className="MaterialListEnumeration__item">
          <TooltipHandler
            openOnClick
            tooltip={
              <Tooltip>
                {more.map((child, index) => (
                  <div key={index}>{child}</div>
                ))}
              </Tooltip>
            }
          >
            <Link>
              + {more.length} {moreLabel}
            </Link>
          </TooltipHandler>
        </li>
      ) : null}
    </ul>
  )
}

export default MaterialListEnumeration
